<template>
  <div class="scroll-wrapper">
    <div class="services-page">
      <div class="services-toolbar">
        <div class="services-toolbar__field">
          <el-select v-model="selectedGroup" placeholder="Группа" clearable filterable>
            <el-option v-for="group in groups" :key="group.id" :label="group.name" :value="group.id" />
          </el-select>
        </div>
        <div class="services-toolbar__field">
          <el-select v-model="selectedCity" placeholder="Город" clearable filterable>
            <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
          </el-select>
        </div>
        <div class="services-toolbar__field">
          <el-input v-model="searchText" clearable placeholder="Поиск услуги..." />
        </div>
        <div class="services-toolbar__actions">
          <el-button type="primary" @click="openServiceModal">Добавить услугу</el-button>
          <el-button @click="openGroupModal">Группы</el-button>
        </div>
      </div>

      <div class="services-table-shell">
        <el-table :data="filteredServices" class="services-table">
          <el-table-column prop="name" label="Название услуги" min-width="240" />
          <el-table-column prop="group_name" label="Группа" min-width="180" />
          <el-table-column prop="city_name" label="Город" min-width="180" />
          <el-table-column prop="price" label="Цена" min-width="110" />
          <el-table-column prop="duration" label="Длит., мин" min-width="120" />
          <el-table-column label="Действия" width="130" align="center">
            <template #default="scope">
              <div class="services-actions">
                <el-button size="small" :icon="EditPen" circle @click="editService(scope.row)" />
                <el-button size="small" :icon="Delete" type="danger" circle @click="confirmDeleteService(scope.row)" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="services-mobile-list">
        <div class="services-mobile-head">
          <span class="services-mobile-head__cell services-mobile-head__cell--name">Услуга</span>
          <span class="services-mobile-head__cell services-mobile-head__cell--group">Группа</span>
          <span class="services-mobile-head__cell services-mobile-head__cell--price">Цена</span>
          <span class="services-mobile-head__cell services-mobile-head__cell--duration">Мин</span>
          <span class="services-mobile-head__cell services-mobile-head__cell--actions"></span>
        </div>

        <article v-for="service in filteredServices" :key="`mobile-service-${service.id}`" class="services-mobile-row">
          <div class="services-mobile-cell services-mobile-cell--name">
            <span class="services-mobile-name-text">{{ service.name }}</span>
            <span class="services-mobile-city-text">{{ service.city_name || '—' }}</span>
          </div>
          <div class="services-mobile-cell services-mobile-cell--group">{{ service.group_name || '—' }}</div>
          <div class="services-mobile-cell services-mobile-cell--price">{{ service.price }} ₽</div>
          <div class="services-mobile-cell services-mobile-cell--duration">{{ service.duration }}</div>
          <div class="services-mobile-cell services-mobile-cell--actions">
            <div class="services-actions services-actions--mobile">
              <el-button size="small" :icon="EditPen" circle @click="editService(service)" />
              <el-button size="small" :icon="Delete" type="danger" circle @click="confirmDeleteService(service)" />
            </div>
          </div>
        </article>
      </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      :page-sizes="[10, 20, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      class="services-pagination"
    />

    <!-- Модалка для создания/редактирования услуги -->
    <el-dialog v-model="showServiceModal" class="services-dialog" :title="serviceForm.id ? 'Редактировать услугу' : 'Добавить услугу'">
      <el-form
        :model="serviceForm"
        :rules="serviceRules"
        ref="serviceFormRef"
        label-width="auto"
        label-position="right"
        status-icon>
        <el-form-item label="Название" prop="name">
          <el-input v-model="serviceForm.name" />
        </el-form-item>
        <el-form-item label="Группа" prop="group_id">
          <div class="services-group-picker">
            <el-select v-model="serviceForm.group_id" placeholder="Выберите группу" filterable class="services-group-picker__select">
              <el-option
                v-for="group in groups"
                :key="group.id"
                :label="group.name"
                :value="group.id"
              />
            </el-select>
            <el-button
              type="primary"
              class="services-group-picker__add"
              @click="showGroupAdd = true">Добавить группу</el-button>
          </div>
        </el-form-item>
        <el-dialog v-model="showGroupAdd" class="services-group-add-dialog" title="Новая группа" width="340px" append-to-body>
          <el-input v-model="newGroupName" placeholder="Название группы" />
          <template #footer>
            <el-button @click="showGroupAdd = false">Отмена</el-button>
            <el-button type="primary" @click="addGroup">Добавить</el-button>
          </template>
        </el-dialog>
        <el-form-item label="Город" prop="city_id">
          <el-select v-model="serviceForm.city_id" placeholder="Выберите город" filterable>
            <el-option v-for="city in cities" :key="city.id" :label="city.name" :value="city.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Цена" prop="price">
          <el-input-number v-model="serviceForm.price" :min="0" />
        </el-form-item>
        <el-form-item label="Длительность (мин)" prop="duration">
          <el-input-number v-model="serviceForm.duration" :min="5" :step="5" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showServiceModal = false">Отмена</el-button>
        <el-button type="primary" @click="saveServiceHandler">Сохранить</el-button>
      </template>
    </el-dialog>

    <!-- Модалка для управления группами -->
    <el-dialog v-model="showGroupModal" class="services-group-dialog" title="Группы услуг">
      <el-table :data="groups" class="services-groups-table">
        <el-table-column prop="name" label="Название группы" />
        <el-table-column label="Действия" width="120">
          <template #default="scope">
            <div class="services-actions">
              <el-button size="small" :icon="EditPen" circle @click="editGroup(scope.row)" />
              <el-button size="small" :icon="Delete" type="danger" circle @click="confirmDeleteGroup(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="services-group-input-row">
        <el-input v-model="groupName" placeholder="Новая группа" />
        <el-button type="primary" @click="addGroupHandler">Добавить</el-button>
      </div>
      <template #footer>
        <el-button @click="showGroupModal = false">Закрыть</el-button>
      </template>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Delete, EditPen } from '@element-plus/icons-vue'

export default {
  name: 'ServicesPage',
  data() {
    return {
      selectedGroup: null,
      selectedCity: null,
      searchText: '',
      showServiceModal: false,
      showGroupModal: false,
      serviceForm: {
        id: null,
        name: '',
        group_id: null,
        city_id: null,
        price: 0,
        duration: 30
      },
      groupName: '',
      showGroupAdd: false,
      newGroupName: '',
      serviceRules: {
        name: [{ required: true, message: 'Укажите название услуги', trigger: 'blur' }],
        group_id: [{ required: true, message: 'Выберите группу', trigger: 'change' }],
        city_id: [{ required: true, message: 'Выберите город', trigger: 'change' }],
        price: [{ required: true, type: 'number', message: 'Укажите цену', trigger: 'blur' }],
        duration: [{ required: true, type: 'number', message: 'Укажите длительность', trigger: 'blur' }]
      },
      page: 1,
      pageSize: 30
    }
  },
  computed: {
    Delete() { return Delete },
    EditPen() { return EditPen },
    ...mapState('services', ['services', 'groups', 'total']),
    ...mapState('cities', ['cities']),
    filteredServices() {
      return this.services.map(s => ({
        ...s,
        group_name: this.groups.find(g => g.id === s.group_id)?.name || '',
        city_name: this.cities.find(c => c.id === s.city_id)?.name || ''
      }))
    }
  },
  mounted() {
    this.fetchServices()
    this.fetchGroups()
    this.getCities()
  },
  watch: {
    selectedGroup() { this.page = 1; this.fetchPage() },
    selectedCity() { this.page = 1; this.fetchPage() },
    searchText() { this.page = 1; this.fetchPage() }
  },
  methods: {
    ...mapActions('services', {
      fetchServices: 'fetchServices',
      saveServiceAction: 'saveService',
      updateServiceAction: 'updateService',
      deleteServiceAction: 'deleteService',
      fetchGroups: 'fetchGroups',
      saveGroup: 'saveGroup',
      updateGroup: 'updateGroup',
      deleteGroup: 'deleteGroup'
    }),
    ...mapActions('cities', ['getCities']),

    async addGroup() {
      if (!this.newGroupName.trim()) return;
      const group = await this.$store.dispatch('services/saveGroup', { name: this.newGroupName });
      this.newGroupName = '';
      this.showGroupAdd = false;
      this.$store.dispatch('services/fetchGroups');
      if (group?.id) this.serviceForm.group_id = group.id;
    },
    openServiceModal() {
      this.serviceForm = { id: null, name: '', group_id: null, city_id: null, price: 0, duration: 30 }
      this.showServiceModal = true
    },
    editService(row) {
      this.serviceForm = { ...row }
      this.showServiceModal = true
    },
    async saveServiceHandler() {
      this.$refs.serviceFormRef.validate(async (valid) => {
        if (valid) {
          if (this.serviceForm.id) {
            await this.updateServiceAction(this.serviceForm)
          } else {
            await this.saveServiceAction(this.serviceForm)
          }
          this.showServiceModal = false
          this.fetchPage()
        }
      })
    },
    // ---- ПОДТВЕРЖДЕНИЕ УДАЛЕНИЯ ----
    confirmDeleteService(row) {
      this.$confirm(
        `Удалить услугу "${row.name}"? Это действие необратимо.`,
        'Подтверждение удаления',
        { type: 'warning' }
      ).then(() => {
        this.deleteServiceHandler(row)
      }).catch(() => {})
    },
    async deleteServiceHandler(row) {
      await this.deleteServiceAction(row.id)
      this.fetchPage()
    },
    openGroupModal() {
      this.groupName = ''
      this.showGroupModal = true
    },
    async addGroupHandler() {
      if (this.groupName.trim()) {
        await this.saveGroup({ name: this.groupName })
        this.groupName = ''
        this.fetchGroups()
      }
    },
    editGroup(row) {
      this.$prompt('Название группы', 'Редактировать группу', {
        confirmButtonText: 'Сохранить',
        cancelButtonText: 'Отмена',
        inputValue: row?.name || '',
        inputPattern: /\S+/,
        inputErrorMessage: 'Введите название группы'
      })
        .then(async ({ value }) => {
          const name = String(value || '').trim()
          if (!name) return
          await this.updateGroup({ id: row.id, name })
          await this.fetchGroups()
          await this.fetchPage()
        })
        .catch(() => {})
    },
    // ---- ПОДТВЕРЖДЕНИЕ УДАЛЕНИЯ ГРУППЫ ----
    confirmDeleteGroup(row) {
      this.$confirm(
        `Удалить группу "${row.name}"? Удаление возможно только если нет связанных услуг.`,
        'Подтверждение удаления',
        { type: 'warning' }
      ).then(() => {
        this.deleteGroupHandler(row)
      }).catch(() => {})
    },
    async deleteGroupHandler(row) {
      await this.deleteGroup(row.id)
      this.fetchGroups()
      this.fetchPage()
    },
    async fetchPage() {
      const filters = {
        group_id: this.selectedGroup,
        city_id: this.selectedCity,
        search: this.searchText,
        page: this.page,
        pageSize: this.pageSize
      }
      await this.fetchServices(filters);
    },
    handlePageChange(val) {
      this.page = val
      this.fetchPage()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.fetchPage()
    },
  }
}
</script>

<style scoped>
.services-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 20px 12px 24px;
  color: var(--cal-text-inverse);
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.services-toolbar {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 14px;
}

.services-toolbar__field,
.services-toolbar__actions {
  min-width: 0;
}

.services-toolbar__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.services-toolbar__actions :deep(.el-button) {
  min-height: 42px;
  border-radius: 9px;
  padding: 0 18px;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.services-toolbar__actions :deep(.el-button:not(.el-button--primary)) {
  background: linear-gradient(180deg, rgba(13, 30, 58, 0.96), rgba(7, 18, 36, 0.96));
  border-color: rgba(110, 146, 214, 0.18);
  color: #d7e7ff;
}

.services-table-shell {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.services-mobile-list {
  display: none;
}

.services-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.services-mobile-head,
.services-mobile-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.82fr) minmax(0, 0.72fr) minmax(0, 0.62fr) 62px;
  gap: 6px;
  align-items: center;
}

.services-mobile-head {
  padding: 0 10px 6px;
}

.services-mobile-head__cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.services-mobile-row {
  min-height: 58px;
  padding: 0 10px;
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  border-radius: 12px !important;
}

.services-mobile-row + .services-mobile-row {
  margin-top: 10px;
}

.services-mobile-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d7e7ff !important;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
  font-size: 12px;
  text-align: center;
}

.services-mobile-cell--name {
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  justify-content: flex-start;
}

.services-mobile-name-text,
.services-mobile-city-text {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.services-mobile-name-text {
  color: #00c3fe;
}

.services-mobile-city-text {
  color: rgba(174, 194, 230, 0.72);
  font-size: 11px;
}

.services-mobile-cell--group,
.services-mobile-cell--price,
.services-mobile-cell--duration {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.services-mobile-cell--actions {
  justify-content: flex-end;
  overflow: visible;
}

.services-actions--mobile {
  gap: 4px;
  width: auto;
  justify-content: flex-end;
}

.services-group-input-row {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.services-group-picker {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.services-group-picker__select,
.services-group-picker__add {
  width: 100%;
}

.services-group-picker__add {
  min-height: 42px;
  justify-content: center;
  margin-top: 0 !important;
}

.services-group-input-row .el-input {
  flex: 1 1 auto;
}

.services-page :deep(.el-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: transparent;
  --el-table-text-color: var(--cal-text-regular);
  --el-table-header-text-color: var(--cal-text-inverse);
  background: transparent;
  min-width: 980px;
}

.services-page :deep(.services-groups-table) {
  min-width: 100%;
}

.services-page :deep(.el-table::before),
.services-page :deep(.el-table__inner-wrapper::before) {
  display: none;
}

.services-page :deep(.el-table th.el-table__cell),
.services-page :deep(.el-table td.el-table__cell) {
  background: transparent;
  border-bottom: 0;
  padding: 0 7px 14px;
}

.services-page :deep(.el-table th.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
  font-size: 21px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.services-page :deep(.el-table td.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  border-radius: 8px !important;
  padding: 0 18px !important;
  color: #00c3fe !important;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
  font-size: 16px !important;
  line-height: 1 !important;
}

.services-page :deep(.el-input__wrapper),
.services-page :deep(.el-select__wrapper),
.services-page :deep(.el-input-number__wrapper) {
  background: #07142d !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  border: none !important;
  min-height: 42px !important;
}

.services-page :deep(.el-input__inner),
.services-page :deep(.el-select__placeholder),
.services-page :deep(.el-select__selected-item),
.services-page :deep(.el-input-number__input) {
  color: #00c3fe !important;
  -webkit-text-fill-color: #00c3fe !important;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
  font-size: 18px !important;
  font-weight: 400 !important;
}

.services-page :deep(.el-button--primary:not(.is-plain)) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.services-page :deep(.el-button.is-circle) {
  background: #0c224b !important;
  border: none !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  color: #244885 !important;
}

.services-page :deep(.el-button.is-circle.el-button--primary:hover) {
  color: #00c3fe !important;
}

.services-page :deep(.el-button.is-circle.el-button--danger:hover) {
  color: #ff6b6b !important;
}

.services-pagination {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 8px;
}

.services-page :deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-button-bg-color: #0c224b;
  --el-pagination-button-color: #aec2e6;
  --el-pagination-text-color: #aec2e6;
  flex-wrap: wrap !important;
  justify-content: flex-end !important;
  row-gap: 8px !important;
}

.services-page :deep(.el-pagination__total) {
  min-width: max-content;
  padding-left: 6px;
}

.services-page :deep(.el-pagination .btn-prev),
.services-page :deep(.el-pagination .btn-next) {
  background: #0c224b !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  border-radius: 8px !important;
  color: #aec2e6 !important;
}

.services-page :deep(.services-dialog.el-dialog),
.services-page :deep(.services-group-dialog.el-dialog),
.services-page :deep(.services-group-add-dialog.el-dialog) {
  width: min(560px, calc(100vw - 20px)) !important;
  background-color: #10244d !important;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #030b1b 0%, #15264e 100%) !important;
  background-image:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(90deg, #030b1b 0%, #15264e 100%) !important;
  border: 1px solid rgba(44, 86, 163, 0.9) !important;
  box-shadow: 0 28px 80px rgba(0, 6, 19, 0.48) !important;
  border-radius: 0 !important;
}

.services-page :deep(.services-group-add-dialog.el-dialog) {
  width: min(360px, calc(100vw - 20px)) !important;
}

.services-page :deep(.services-dialog .el-dialog__header),
.services-page :deep(.services-dialog .el-dialog__body),
.services-page :deep(.services-dialog .el-dialog__footer),
.services-page :deep(.services-group-dialog .el-dialog__header),
.services-page :deep(.services-group-dialog .el-dialog__body),
.services-page :deep(.services-group-dialog .el-dialog__footer),
.services-page :deep(.services-group-add-dialog .el-dialog__header),
.services-page :deep(.services-group-add-dialog .el-dialog__body),
.services-page :deep(.services-group-add-dialog .el-dialog__footer) {
  background: transparent;
}

.services-page :deep(.services-dialog .el-dialog__header),
.services-page :deep(.services-group-dialog .el-dialog__header),
.services-page :deep(.services-group-add-dialog .el-dialog__header) {
  padding: 14px 16px 0;
}

.services-page :deep(.services-dialog .el-dialog__body),
.services-page :deep(.services-group-dialog .el-dialog__body),
.services-page :deep(.services-group-add-dialog .el-dialog__body) {
  padding: 10px 16px 14px;
}

.services-page :deep(.services-dialog .el-dialog__footer),
.services-page :deep(.services-group-dialog .el-dialog__footer),
.services-page :deep(.services-group-add-dialog .el-dialog__footer) {
  padding: 8px 16px 16px;
}

.services-page :deep(.services-dialog .el-dialog__title),
.services-page :deep(.services-dialog .el-form-item__label),
.services-page :deep(.services-group-dialog .el-dialog__title),
.services-page :deep(.services-group-add-dialog .el-dialog__title) {
  color: #ffffff !important;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif !important;
}

.services-page :deep(.services-dialog .el-input-number) {
  width: 100% !important;
}

.services-page :deep(.services-dialog .el-input-number__decrease),
.services-page :deep(.services-dialog .el-input-number__increase) {
  background: rgba(15, 34, 72, 0.96) !important;
  color: #00c3fe !important;
  border-color: rgba(77, 120, 198, 0.28) !important;
}

@media (max-width: 1024px) {
  .services-toolbar {
    grid-template-columns: 1fr 1fr;
  }

  .services-toolbar__actions {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  .services-page {
    padding: 14px 12px 20px;
  }

  .services-table-shell {
    display: block;
  }

  .services-mobile-list {
    display: none !important;
  }

  .services-toolbar {
    grid-template-columns: 1fr;
  }

  .services-toolbar__actions {
    justify-content: stretch;
    flex-direction: column;
  }

  .services-toolbar__actions :deep(.el-button) {
    width: 100%;
    margin-left: 0 !important;
  }

  .services-group-input-row {
    flex-direction: column;
    align-items: stretch;
  }

  .services-pagination {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .services-page {
    padding: 8px 10px 14px;
  }

  .services-page :deep(.el-table) {
    min-width: 880px;
  }

  .services-page :deep(.el-table th.el-table__cell),
  .services-page :deep(.el-table td.el-table__cell) {
    padding: 0 5px 10px;
  }

  .services-page :deep(.el-table th.el-table__cell .cell) {
    min-height: 42px;
    font-size: 14px !important;
  }

  .services-page :deep(.el-table td.el-table__cell .cell) {
    min-height: 44px;
    padding: 0 10px !important;
    font-size: 12px !important;
  }

  .services-page :deep(.el-button.is-circle) {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
  }
}
</style>
